import { FC } from 'react'
import styled from 'styled-components'
import { Card } from 'antd'

import PerIcon from '../Icon'
import { IconNames } from '../../util/types'

import './index.less'

interface IconCardProps {
  icon: IconNames
  size?: number
}

const IconWraper = styled.div<{ size: number }>`
  width: ${(props) => props.size + 10 + 'px'};
  height: ${(props) => props.size + 10 + 'px'};
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
`

export const IconCard: FC<IconCardProps> = ({ children, icon, size = 20 }) => {
  return (
    <Card className="per-icon-card fullHeight" bordered={false}>
      <IconWraper size={size}>
        <div className="per-icon-card--icon">
          <PerIcon size={size} name={icon} color="white" />
        </div>
      </IconWraper>
      {children}
    </Card>
  )
}
